import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import Spinner from '../../../shared/spinner';
import { format, parse } from 'date-fns';
import { Empregador } from '../../../shared/model/empregador';
import { Promotora } from '../../../shared/model/promotora';
import DateInput from '../../../shared/dateInput';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RelatoriosDTO } from '../../../shared/dto/relatoriosDTO';
import PromotoraService from '../../../services/promotoraService';
import EmpregadorService from '../../../services/empregadorService';
import CustomAlert from '../../../shared/customAlert';
import RelatorioService from '../../../services/relatorioService';
import RelatoriosAgendadosService from '../../../services/relatoriosAgendadosService';
import { AgendarRelatorioDTO } from '../../../shared/dto/agendarRelatorioDTO';
import OriginadorService from '../../../services/originadorService';
import { Originador } from '../../../shared/model/originador';
import { getTodayInputDate, inputDateToLocalDateTimeString, isInputDateBeforeToday } from '../../../shared/agendamentoRelatorioData';

function OperacoesRealizadasComponent() {

  const [showAgendamentoModal, setShowAgendamentoModal] = useState(false);
  const [errorRelatorio, setErrorRelatorio] = useState<string | null>(null);

  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const [loading, setLoading] = useState(false);

  const [dtBase1, setDtBase1] = useState(format(new Date(), 'dd/MM/yyyy'));
  const [dtBase2, setDtBase2] = useState(format(new Date(), 'dd/MM/yyyy'));

  // --- ESTADOS DO ORIGINADOR (DUAL LIST BOX) ---
  const [availableOriginadores, setAvailableOriginadores] = useState<Originador[]>([]);
  const [selectedOriginadores, setSelectedOriginadores] = useState<Originador[]>([]);
  const [selectedToMoveOriginadores, setSelectedToMoveOriginadores] = useState<Originador[]>([]);
  const [selectedFromSelectedOriginadores, setSelectedFromSelectedOriginadores] = useState<Originador[]>([]);

  const [availablePromotoras, setAvailablePromotoras] = useState<Promotora[]>([]);
  const [selectedPromotoras, setSelectedPromotoras] = useState<Promotora[]>([]);
  const [selectedToMovePromotoras, setSelectedToMovePromotoras] = useState<Promotora[]>([]);
  const [selectedFromSelectedPromotoras, setSelectedFromSelectedPromotoras] = useState<Promotora[]>([]);

  const [availableEmpregadores, setAvailableEmpregadores] = useState<Empregador[]>([]);
  const [selectedEmpregadores, setSelectedEmpregadores] = useState<Empregador[]>([]);
  const [selectedToMoveEmpregadores, setSelectedToMoveEmpregadores] = useState<Empregador[]>([]);
  const [selectedFromSelectedEmpregadores, setSelectedFromSelectedEmpregadores] = useState<Empregador[]>([]);

  const [totalLinhasRelatorio, setTotalLinhasRelatorio] = useState<number | null>(null);

  const [agendamentoData, setAgendamentoData] = useState(getTodayInputDate);


  const relatoriosAgendadosService = new RelatoriosAgendadosService();
  const relatorioService: RelatorioService = new RelatorioService();
  const promotoraService: PromotoraService = new PromotoraService();
  const empregadorService: EmpregadorService = new EmpregadorService();
  const originadorService: OriginadorService = new OriginadorService();

  const listarPromotoras = async () => {
    setLoading(true);
    try {
      const response = await promotoraService.listarTodasPromotorasAtivas();
      setAvailablePromotoras(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const listarEmpregadores = async () => {
    setLoading(true);
    try {
      const response = await empregadorService.listarTodosEmpregadoresAtivos();
      setAvailableEmpregadores(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const listarOriginadores = async () => {
    setLoading(true);
    try {
        const response = await originadorService.listarTodasOriginadoresPorRole(); 
        setAvailableOriginadores(response.data);
        // setSelectedOriginadores([]); // Comentado para evitar limpar ao recarregar
        setLoading(false);
    } catch (err) {
        setLoading(false);
        console.error(err);
    }
  };

  // --- NOVA LÓGICA: FILTRAR PROMOTORAS AO SELECIONAR ORIGINADOR ---
  useEffect(() => {
    const atualizarPromotorasPorOriginador = async () => {
        
        // Se tiver originadores selecionados, busca filtrado
        if (selectedOriginadores.length > 0) {
          setLoading(true);
          try {
            const idsOriginadores = selectedOriginadores.map(o => o.id);
            const response = await promotoraService.buscarPorOriginador(idsOriginadores);
            
            // Filtra para não mostrar nas disponíveis as que JÁ estão nas selecionadas
            const novasDisponiveis = response.data.filter((p: any) => 
              !selectedPromotoras.some((sel: any) => sel.id === p.id)
            );

            setAvailablePromotoras(novasDisponiveis);
          } catch (err) {
            console.error("Erro ao filtrar promotoras por originador", err);
            setAlert({ message: 'Erro ao filtrar promotoras', type: 'error' });
          } finally {
            setLoading(false);
          }
        } else {
          // Se limpar os originadores, volta a listar todas as promotoras
          listarPromotoras();
        }
    };

    atualizarPromotorasPorOriginador();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOriginadores]); 
  // ----------------------------------------------------------------

  const gerarRelatorio = async () => {
    // if (selectedOriginadores.length <= 0) return setAlert({ message: 'Selecione ao menos um Originador', type: 'warning' }); // Validação Opcional
    if (selectedPromotoras.length <= 0) return setAlert({ message: 'Selecione ao menos uma Promotora', type: 'warning' });
    if (selectedEmpregadores.length <= 0) return setAlert({ message: 'Selecione ao menos um Empregador', type: 'warning' });
    if (dtBase1 === '' || dtBase2 === '') return setAlert({ message: 'Preencha os campos de datas!', type: 'warning' });
    if (dtBase1 !== '' && dtBase2 !== '' && parse(dtBase1, "dd/MM/yyyy", new Date()) > parse(dtBase2, "dd/MM/yyyy", new Date())) return setAlert({ message: 'Data inicial deve ser inferior a data final', type: 'warning' });
    setLoading(true);
    try {
      const dto: RelatoriosDTO = new RelatoriosDTO();
      dto.empregadores = selectedEmpregadores;
      dto.promotoras = selectedPromotoras;
      dto.dtBase1 = parse(dtBase1, "dd/MM/yyyy", new Date());
      dto.dtBase2 = parse(dtBase2, "dd/MM/yyyy", new Date());
      
      (dto as any).originadorIds = selectedOriginadores.map(o => o.id);

      const response = await relatorioService.gerarRelatorioOperacaoRealizada(dto);

      const contentType = response.headers['content-type'];

      if (contentType === 'text/plain') {
        const errorText = await response.data.text();
        setAlert({ message: errorText, type: 'warning' });
      } else {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', 'Relatorio_Operacoes_Realizadas.xlsx');

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }

      setLoading(false);
    } 

    catch (err: any) {
      setLoading(false);

      (async () => {
        if (err.response && err.response.status === 500 && err.response.data instanceof Blob) {
          try {
            const errorText = await err.response.data.text();
            const parsed = JSON.parse(errorText);

            if (parsed && typeof parsed === 'object' && 'message' in parsed) {
              setErrorRelatorio(parsed.message); 
              setTotalLinhasRelatorio(parsed.totalRows); 
            } else {
              setErrorRelatorio(errorText); 
            }

          } catch (parseError) {
            setErrorRelatorio('Erro desconhecido ao gerar relatório.');
          }
          setShowAgendamentoModal(true);
          return;

        } else if (err.response && err.response !== 'AXIOS_TIMEOUT') {
          setAlert({ message: 'Ocorreu um erro ao gerar o relatório', type: 'error' });
        }
        console.error(err);
      })();

    }
  }

  useEffect(() => {
    listarPromotoras();
    listarEmpregadores();
    listarOriginadores();
  }, []);

  //Agendamento de Relatorio
  const agendarRelatorio = async () => {
    const userId = localStorage.getItem("id") ?? ""; 

    if (!agendamentoData) {
      setAlert({ message: "Por favor, selecione a data do agendamento.", type: "warning" });
      return;
    }

    if (isInputDateBeforeToday(agendamentoData)) {
      setAlert({ message: `A data de agendamento não pode ser anterior a hoje.`, type: "warning" });
      return;
    }

    const parametros = {
      dtBase1: format(parse(dtBase1, "dd/MM/yyyy", new Date()), "yyyy-MM-dd"),
      dtBase2: format(parse(dtBase2, "dd/MM/yyyy", new Date()), "yyyy-MM-dd"),
      empregadorIds: selectedEmpregadores.map(e => e.id),
      promotoraIds: selectedPromotoras.map(p => p.id),
      originadorIds: selectedOriginadores.map(o => o.id)
    };

    const dto: AgendarRelatorioDTO = {
      userId,
      tipoRelatorio: "OPERACOES-REALIZADAS",
      parametros: JSON.stringify(parametros),
      qtdeLinhas: totalLinhasRelatorio ?? 0,
      programado: inputDateToLocalDateTimeString(agendamentoData)
    };

    try {
      const response = await relatoriosAgendadosService.solicitarRelatorio(dto);

      if (response.status === 200) {
        setAlert({ message: "Relatório agendado com sucesso!", type: "success" });
      } else {
        setAlert({ message: "Erro ao agendar relatório.", type: "error" });
      }
    } catch (err: any) {
      const msg = err.response?.data || "Erro inesperado ao agendar relatório.";
      setAlert({ message: msg, type: "error" });
      console.error(err);
    } finally {
      setShowAgendamentoModal(false);
      setErrorRelatorio(null);
      setAgendamentoData(""); 
    }
  };

  // --- FUNÇÕES DE MOVIMENTAÇÃO (ORIGINADOR) ---
  const moveToSelectedOriginadores = () => {
    const newSelected = [...selectedOriginadores, ...selectedToMoveOriginadores];
    const newAvailable = availableOriginadores.filter((o) => !selectedToMoveOriginadores.includes(o));
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores(newSelected);
    setSelectedToMoveOriginadores([]);
  };

  const moveToAvailableOriginadores = () => {
    const newAvailable = [...availableOriginadores, ...selectedFromSelectedOriginadores];
    const newSelected = selectedOriginadores.filter((o) => !selectedFromSelectedOriginadores.includes(o));
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores(newSelected);
    setSelectedFromSelectedOriginadores([]);
  };

  const moveAllToSelectedOriginadores = () => {
    const newSelected = [...selectedOriginadores, ...availableOriginadores];
    setSelectedOriginadores(newSelected);
    setAvailableOriginadores([]);
  };

  const moveAllToAvailableOriginadores = () => {
    const newAvailable = [...availableOriginadores, ...selectedOriginadores];
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores([]);
  };
  // --------------------------------------------------------


  const moveToSelectedPromotoras = () => {
    const newSelected = [...selectedPromotoras, ...selectedToMovePromotoras];
    const newAvailable = availablePromotoras.filter(
      (promotora) => !selectedToMovePromotoras.includes(promotora)
    );

    setAvailablePromotoras(newAvailable);
    setSelectedPromotoras(newSelected);
    setSelectedToMovePromotoras([]);
  };

  const moveToAvailablePromotoras = () => {
    const newAvailable = [...availablePromotoras, ...selectedFromSelectedPromotoras];
    const newSelected = selectedPromotoras.filter(
      (promotora) => !selectedFromSelectedPromotoras.includes(promotora)
    );

    setAvailablePromotoras(newAvailable);
    setSelectedPromotoras(newSelected);
    setSelectedFromSelectedPromotoras([]);
  };

  const moveAllToSelectedPromotoras = () => {
    const newSelected = [...selectedPromotoras, ...availablePromotoras];
    setSelectedPromotoras(newSelected);
    setAvailablePromotoras([]);
  };

  const moveAllToAvailablePromotoras = () => {
    const newAvailable = [...availablePromotoras, ...selectedPromotoras];
    setAvailablePromotoras(newAvailable);
    setSelectedPromotoras([]);
  };

  //EMPREGADOR

  const moveToSelectedEmpregadores = () => {
    const newSelected = [...selectedEmpregadores, ...selectedToMoveEmpregadores];
    const newAvailable = availableEmpregadores.filter(
      (empregador) => !selectedToMoveEmpregadores.includes(empregador)
    );

    setAvailableEmpregadores(newAvailable);
    setSelectedEmpregadores(newSelected);
    setSelectedToMoveEmpregadores([]);
  };

  const moveToAvailableEmpregadores = () => {
    const newAvailable = [...availableEmpregadores, ...selectedFromSelectedEmpregadores];
    const newSelected = selectedEmpregadores.filter(
      (empregador) => !selectedFromSelectedEmpregadores.includes(empregador)
    );

    setAvailableEmpregadores(newAvailable);
    setSelectedEmpregadores(newSelected);
    setSelectedFromSelectedEmpregadores([]);
  };

  const moveAllToSelectedEmpregadores = () => {
    const newSelected = [...selectedEmpregadores, ...availableEmpregadores];
    setSelectedEmpregadores(newSelected);
    setAvailableEmpregadores([]);
  };

  const moveAllToAvailableEmpregadores = () => {
    const newAvailable = [...availableEmpregadores, ...selectedEmpregadores];
    setAvailableEmpregadores(newAvailable);
    setSelectedEmpregadores([]);
  };

  return (
    <>
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={()=>setAlert(null)} />)}
      

      {showAgendamentoModal && (
        <div className="modal fade show d-block" tabIndex={-1} role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Agendar Relatório</h5>
                <button type="button" className="close" aria-label="Fechar" onClick={() => setShowAgendamentoModal(false)}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>{errorRelatorio}</p>
                <p>Deseja agendar o relatório com os filtros preenchidos?</p>
                  <div className="form-group">
                    <label htmlFor="dataAgendamento"><b>Data do Agendamento:</b></label>
                    <input
                      id="dataAgendamento"
                      type="date"
                      required
                      className="form-control"
                      value={agendamentoData}
                      onChange={(e) => setAgendamentoData(e.target.value)}
                      min={getTodayInputDate()}
                    />
                  </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowAgendamentoModal(false)}>Cancelar</button>
                <button className="btn btn-primary" onClick={agendarRelatorio}>Agendar</button>
              </div>
            </div>
          </div> 
        </div>
      )}


      <div className="position-relative m-md-3"> 
        {loading ? <Spinner loading={loading} /> : (
          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>Relatório de Operações Realizadas</strong>
            </div>
            <div className="card-body">
              <div className="" style={{ marginTop: '10px' }}>
                <div className="row">
                  <div className="col-md-2" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    <label>Período de Data Base <span style={{ color: 'red' }}>*</span></label>
                  </div>
                </div>
                <div className="row" style={{ marginTop: '5px' }}>
                  <div className="col-md-4">
                    <thead>
                      <tr>
                        <th style={{ width: "150px" }}><DateInput required className="form-control" type="text" value={dtBase1} onChange={(e) => setDtBase1((e.target.value).replace(/_/g, ""))} /></th>
                        <th style={{ width: "15px" }}> a </th>
                        <th style={{ width: "150px" }}><DateInput required className="form-control" type="text" value={dtBase2} onChange={(e) => setDtBase2((e.target.value).replace(/_/g, ""))} /></th>
                      </tr>
                    </thead>
                  </div>
                </div>
              </div>

              {/* --- DUAL LIST BOX PARA ORIGINADOR (ACIMA DE PROMOTORAS) --- */}
              <div style={{ display: 'flex', marginTop: '10px' }}>
                <div>
                  <h6>{Originador.DESCRITIVO_GERAL}s Disponíveis</h6>
                  <select
                    multiple
                    value={selectedToMoveOriginadores.map((p) => p.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const item = availableOriginadores.find(p => p.id!.toString() === options[i].value);
                          if (item) selected.push(item);
                        }
                      }
                      setSelectedToMoveOriginadores(selected);
                    }}
                    style={{ width: '575px', height: '250px' }}
                  >
                    {availableOriginadores.map((orig) => (
                      <option key={orig.id} value={orig.id!.toString()}>
                        {orig.id} - {orig.nome!}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <button onClick={moveToSelectedOriginadores} style={{ margin: '5px' }}>{'>'}</button>
                  <button onClick={moveAllToSelectedOriginadores} style={{ margin: '5px' }}>{'>>'}</button>
                  <button onClick={moveToAvailableOriginadores} style={{ margin: '5px' }}>{'<'}</button>
                  <button onClick={moveAllToAvailableOriginadores} style={{ margin: '5px' }}>{'<<'}</button>
                </div>
                <div>
                  <h6>{Originador.DESCRITIVO_GERAL} Selecionados</h6>
                  <select
                    multiple
                    value={selectedFromSelectedOriginadores.map((p) => p.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const item = selectedOriginadores.find(p => p.id!.toString() === options[i].value);
                          if (item) selected.push(item);
                        }
                      }
                      setSelectedFromSelectedOriginadores(selected);
                    }}
                    style={{ width: '575px', height: '250px' }}
                  >
                    {selectedOriginadores.map((orig) => (
                      <option key={orig.id} value={orig.id!.toString()}>
                        {orig.id} - {orig.nome!}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {/* ------------------------------------------------------------- */}

              <div style={{ display: 'flex', marginTop: '10px' }}>
                <div>
                  <h6>Promotoras Disponíveis</h6>
                  <select
                    multiple
                    value={selectedToMovePromotoras.map((p) => p.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const promotora = availablePromotoras.find(p => p.id!.toString() === options[i].value);
                          if (promotora) {
                            selected.push(promotora);
                          }
                        }
                      }
                      setSelectedToMovePromotoras(selected);
                    }}
                    style={{ width: '575px', height: '250px' }}
                  >
                    {availablePromotoras.map((promotora) => (
                      <option key={promotora.id} value={promotora.id!.toString()}>
                        {promotora.id} - {promotora.nome!}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <button onClick={moveToSelectedPromotoras} style={{ margin: '5px' }}>{'>'}</button>
                  <button onClick={moveAllToSelectedPromotoras} style={{ margin: '5px' }}>{'>>'}</button>
                  <button onClick={moveToAvailablePromotoras} style={{ margin: '5px' }}>{'<'}</button>
                  <button onClick={moveAllToAvailablePromotoras} style={{ margin: '5px' }}>{'<<'}</button>
                </div>
                <div>
                  <h6>Promotoras Selecionadas</h6>
                  <select
                    multiple
                    value={selectedFromSelectedPromotoras.map((p) => p.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const promotora = selectedPromotoras.find(p => p.id!.toString() === options[i].value);
                          if (promotora) {
                            selected.push(promotora);
                          }
                        }
                      }
                      setSelectedFromSelectedPromotoras(selected);
                    }}
                    style={{ width: '575px', height: '250px' }}
                  >
                    {selectedPromotoras.map((promotora) => (
                      <option key={promotora.id} value={promotora.id!.toString()}>
                        {promotora.id} - {promotora.nome!}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div style={{ display: 'flex', marginTop: '10px' }}>
                <div>
                  <h6>Empregadores Disponíveis </h6>
                  < select
                    multiple
                    value={selectedToMoveEmpregadores.map((e) => e.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const empregador = availableEmpregadores.find(e => e.id!.toString() === options[i].value);
                          if (empregador) {
                            selected.push(empregador);
                          }
                        }
                      }
                      setSelectedToMoveEmpregadores(selected);
                    }}
                    style={{ width: '575px', height: '250px' }}
                  >
                    {
                      availableEmpregadores.map((empregador) => (
                        <option key={empregador.id} value={empregador.id!.toString()} >
                          {empregador.id} - {empregador.nome!}
                        </option>
                      ))
                    }
                  </select>
                </div>
                < div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <button onClick={moveToSelectedEmpregadores} style={{ margin: '5px' }}> {'>'} </button>
                  < button onClick={moveAllToSelectedEmpregadores} style={{ margin: '5px' }}> {'>>'} </button>
                  < button onClick={moveToAvailableEmpregadores} style={{ margin: '5px' }}> {'<'} </button>
                  < button onClick={moveAllToAvailableEmpregadores} style={{ margin: '5px' }}> {'<<'} </button>
                </div>
                < div >
                  <h6>Empregadores Selecionados </h6>
                  < select
                    multiple
                    value={selectedFromSelectedEmpregadores.map((e) => e.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const empregador = selectedEmpregadores.find(e => e.id!.toString() === options[i].value);
                          if (empregador) {
                            selected.push(empregador);
                          }
                        }
                      }
                      setSelectedFromSelectedEmpregadores(selected);
                    }}
                    style={{ width: '575px', height: '250px' }}
                  >
                    {
                      selectedEmpregadores.map((empregador) => (
                        <option key={empregador.id} value={empregador.id!.toString()} >
                          {empregador.id} - {empregador.nome!}
                        </option>
                      ))
                    }
                  </select>
                </div>
              </div>

              <div className="row" style={{ marginTop: '20px', height: '50px', maxWidth: '70%' }}>
                <div className="col-md-3">
                  <button className="input-group-btn" id="App-button-cor-principal"
                    style={{
                      width: '80%', display: 'flex', alignItems: 'center',
                      justifyContent: 'center', border: '1px solid LightGrey', borderRadius: '5px', height: '100%', minWidth: '50px'
                    }}onClick={gerarRelatorio}>
                    <a>
                      <FontAwesomeIcon icon={faPrint} style={{ color: 'White', fontSize: 'larger', marginTop: '5px' }} />
                    </a>
                    <strong style={{ color: 'White', marginLeft: '5px', fontSize: 'larger' }}> Gerar Relatório</strong>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div >
    </>
  );
}

export default OperacoesRealizadasComponent;
